/**
 * Bundle upsell — agregado al carrito por AJAX.
 *
 * El clic en la tarjeta lo maneja un enlace superpuesto en el Liquid,
 * no este archivo. Aquí solo vive la lógica del botón.
 *
 * El <form> del bloque sigue siendo el respaldo: si el JS no carga,
 * el navegador lo envía de forma nativa y todo sigue funcionando.
 */

// Coinciden con ThemeEvents.cartUpdate y ThemeEvents.cartError en events.js
const CART_UPDATE_EVENT = 'cart:update';
const CART_ERROR_EVENT = 'cart:error';

const routeRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

class BundleUpsellCard extends HTMLElement {
  #busy = false;

  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('[data-bundle-submit]');

    if (!this.form || !this.button) return;

    this.form.addEventListener('submit', this.#handleSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.#handleSubmit);
  }

  #handleSubmit = async (event) => {
    event.preventDefault();

    if (this.#busy) return;
    this.#busy = true;
    this.button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${routeRoot()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: new FormData(this.form),
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        this.#dispatchError(error);
        return;
      }

      // /cart/add.js devuelve las líneas agregadas, no el carrito completo.
      const cart = await fetch(`${routeRoot()}cart.js`).then((res) => res.json());

      document.dispatchEvent(
        new CustomEvent(CART_UPDATE_EVENT, {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: this.id,
            data: {
              source: 'bundle-upsell',
              itemCount: cart.item_count,
            },
          },
        })
      );
    } catch (error) {
      this.#dispatchError({ message: error.message });
    } finally {
      this.#busy = false;
      this.button.removeAttribute('aria-busy');
    }
  };

  #dispatchError(payload) {
    document.dispatchEvent(
      new CustomEvent(CART_ERROR_EVENT, {
        bubbles: true,
        detail: {
          sourceId: this.id,
          data: {
            message: payload.message,
            description: payload.description,
            errors: payload.errors,
          },
        },
      })
    );
  }
}

if (!customElements.get('bundle-upsell-card')) {
  customElements.define('bundle-upsell-card', BundleUpsellCard);
}